var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.3665 23V12.9457h3.3846l.4978-3.88235h-3.8824V6.57466c0-1.09502.2987-1.8914 1.8914-1.8914h2.0905V1.1991C16.9502 1.1991 15.7557 1 14.362 1c-2.9864 0-4.97738 1.79186-4.97738 5.17647v2.88688H6v3.88235h3.38462V23h3.98188z","fill":"#fff"}));
}

Facebook.defaultProps = {"fill":"none","viewBox":"0 0 24 24"};

module.exports = Facebook;

Facebook.default = Facebook;
